<template>
  <footer :class="['page-footer',footerClassName]">
    <p v-if="goodsPrice" class="goods-price">
      <span>总计:</span>
      <span class="red-text">
        <i class="iconfont icon-renminbi"></i>
      </span>
    </p>
    <button v-if="go_mask" @click="goMask">{{btnText}}</button>
    <button v-if="goodsPrice">{{btnText}}</button>
    <button v-if="save_info">{{btnText}}</button>

    <div v-if="bottomNav" class="indexBotNav-wrap">
      <a
      v-for="(item,index) in bottomNav.navItem"
      :key="index"
      href="">
        {{item.textContent}}
      </a>
    </div>

  </footer>
</template>

<script>
  export default {
    name: "page-footer",
    props: {
      btnText: {
        type: String,
        required: false,
      },
      goodsPrice: {
        type: Boolean,
        required: false,
      },
      go_mask: {
        type: Boolean,
        required: false,
      },
      save_info: {
        type: Boolean,
        required: false,
      },
      footerClassName: {
        type: String,
        required: false,
      },
      //bottomNav---------
      bottomNav:{
        type: Object,
        required: false,
      },

    },
    data() {
      return {

      }
    },
    methods: {
      goMask() {
        this.$emit("triggerMask", "showMask");
      },
    }

  }
</script>

<style lang="less">
  @import '../../style/public';
  @import '../../style/variable';

  .page-footer {
    .flex_wrap(initial, center, initial, initial);
    border-top: 1px solid #ddd;
    background-color: #fff;

    button {
      .btn();
      .primarybtnColor();
      .border-T();
      font-size: .4rem;
    }

    .goods-price {
      flex: 0 0 67%;
      text-align: right;
      padding-right: 3%;

      &>span:last-child {
        margin-right: 5px;
      }
    }
  }

  .indexBotNav-wrap{
    background-color:#fff;
    .blockPadding();
    .fixedBot();
    .flex_wrap(center, center, initial, initial);

    a{
      text-align: center;
      line-height: .8rem;
      .flex_items();
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/child-components/Footer.vue